var m_ak = 'swGE4fFW6Cun2a7Fovg0qz86';


var m_provinces = null;
var m_cur_cities = null;
var m_position = {
	city:'定位中',
	province:'点击选择省份',
	lat: 0,
	lng: 0
};

//$.getJSON('/open/s-open/mycity',function(data){
//	//console.log(data);
//	m_position = data||m_position;
//	$('#current_city').text(m_position.city);
//	if(!data){
//		console.log('定位失败,请手动设置您的城市');
//	}
//	//m_provinces = m_position.provinces;
//})



var getProvinceList = function() {
	$.get('/open/province',
		function(data) {
			if (data.status == 'ok'){
				m_provinces = data ;
			}
		},
		'json'
	);
}

$('#open-city').click(function(){
	initProvCity(m_position.province);

})



var initProvCity = function(provName){
	//div = $("<button id='cur_prov' class='btn btn-default'><span class='glyphicon glyphicon-chevron-left'></span>" + provName + "</div>");
	$('.curr_city').text(m_position.city);
	if ($('#city_items').children().length == 0 || $('#cur_prov').text() === '省份'){
		$.get(
			'/open/city?pname=' + provName,
			function(data){
				if (data.status == 'ok') {
					m_cur_cities = data.list;
					printCities();
				}
			},
			'json'
		);
	}
	$('#cur_prov').text(provName);
	$(".menu-wrap").addClass("menu-wrap-open");
    $(".content-wrap").css("display","block");
}

var initProvenceList = function() {
	$('#city_items').empty();
	$('#cur_prov').text('省份');
	for (var i =0; i < m_provinces.list.length; i++ ){
		var a = $('<a href="javascript:;"><span></span></a>');
		a.data('prov', m_provinces.list[i]['name']);
		a.attr('data-prov', m_provinces.list[i]['name']);
		a.find('span').text(m_provinces.list[i]['name']);
		a.click(function(){
			selectProvCity(this);
		});
		$('#city_items').append(a);
	}
}

var selectProvCity = function(obj) {
	$('#city_items').empty();
	initProvCity($(obj).data('prov'));
}

var printCities = function() {
	for (var i = 0; i < m_cur_cities.length; i++) {
		var a = $('<a href="javascript:;"><span></span></a>');
		a.data('city', m_cur_cities[i].city_name);
		a.attr('data-city', m_cur_cities[i].city_name);
		a.find('span').text(m_cur_cities[i].city_name);
		a.click(function() {
			selectCity(this);
		});
		$('#city_items').append(a);
	}
}

var selectCity = function(obj){
	$.ajax({
		url: '/open/s-open/setPosition',
		type: 'get',
		dataType: 'json',
		data: {
			city: $(obj).data('city'),
			province: $('#cur_prov').text(),
		},
		success: function(data) {
			m_position = data;
			$('#current_city').text(data.city);
			$(".menu-wrap").removeClass("menu-wrap-open");
        	$(".content-wrap").css("display","none");
		},
		error: function(data){}
	});
}

var displayPosition = function(pos) {
    //var properties = ['longitude', 'latitude', 'altitude', 'accuracy', 'altitudeAccuracy', 'heading', 'speed'];
	showCityByLocation(pos.coords['latitude'], pos.coords['longitude']);
}

var getPositionError = function(error) {
    console.log(error);
    switch (error.code) {
        case error.TIMEOUT:
            //alert('time out');
            break;
        case error.PERMISSION_DENIED:
            //alert('permission denied');
            break;
        case error.POSITION_UNAVAILABLE:
            alert('无法获取位置');
            break;
    }
}

var showCityByLocation = function(lat, lng) {
	if (window.AlipayJSBridge) {
		return;
	}
	var url = 'https:' == document.location.protocol ? 'https://': 'http://';
	$.ajax ({
		url: url + 'api.map.baidu.com/geocoder/v2/?ak=' + m_ak + '&location=' + lat + ',' + lng + '&output=json&pois=0',
		type: 'get',
		dataType: 'jsonp',
		jsonp: 'callback',
		success: function(data){
			if (data.status == 0) {
				$.ajax({
					url: '/open/initPosition',
					type: 'post',
					dataType: 'json',
					headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
					data: {
						city: 		data.result.addressComponent.city.substr(0, data.result.addressComponent.city.length - 1),
						province: 	data.result.addressComponent.province.substr(0, data.result.addressComponent.province.length - 1),
						lat: 		lat,
						lng: 		lng,
					},
					success: function(data){
						if(data.status=='no'){
							$("#city_dlg").show();
							$("#citycache").html(data.city);
							$("#curr_city").html(data.curr_city);
						}else{
							m_position = data.position,
							$('#current_city').text(data.position.city);
							$('#temp_city').html(data.position.city);
						}
					},
					error: function(data){}
				});
			}
		}
	})
}


var showCityByLocationWx = function(lng,lat) {
	var g_key='3b5cd3eb2743b703751dc2fffcda09fe';
	if (window.AlipayJSBridge) {
		return;
	}
	$.ajax ({
		url: 'http://restapi.amap.com/v3/geocode/regeo?key=' + g_key + '&location=' + lat + ',' + lng + '&output=json&poitype=1000&radius=1000&extensions=base&batch=false&roadlevel=1',
		type: 'get',
		dataType: 'jsonp',
		jsonp: 'callback',
		success: function(data){
			if (data.status == 1) {
				var typecity=typeof data.regeocode.addressComponent.city;
				if(typecity !='string'){
					data.regeocode.addressComponent.city=data.regeocode.addressComponent.province;
				}
				$.ajax({
					url: '/open/initPosition',
					type: 'post',
					dataType: 'json',
					headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
					data: {
						city: 		data.regeocode.addressComponent.city.substr(0, data.regeocode.addressComponent.city.length - 1),
						province: 	data.regeocode.addressComponent.province.substr(0, data.regeocode.addressComponent.province.length - 1),
						lat: 		lat,
						lng: 		lng,
					},
					success: function(data){
						if(data.status=='no'){
							$("#city_dlg").show();
							$("#citycache").html(data.city);
							$("#curr_city").html(data.curr_city);
						}else{
							m_position = data.position;
							$('#current_city').text(data.position.city);
							$('#temp_city').text(data.position.city);
						}
					},
					error: function(data){}
				});
			}else{
				alert('定位失败,请手动设置您的城市');
			}
		}
	})
}

//初始化
//getProvinceList();
